import { render, staticRenderFns } from "./Usados.vue?vue&type=template&id=6495b926"
import script from "./Usados.vue?vue&type=script&lang=js"
export * from "./Usados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports